(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-tew-bottle="750"]';
  const pending = new WeakSet();
  function normalize(frame) {
    const img = frame.querySelector('.product-media__image');
    if (!img || pending.has(img)) return;
    pending.add(img);
    const run = (source = img) => {
      if (!img.naturalWidth || !img.naturalHeight) return;
      try {
        const canvas = document.createElement('canvas');
        const ratio = img.naturalWidth / img.naturalHeight;
        canvas.height = 240; canvas.width = Math.max(1, Math.round(240 * ratio));
        const ctx = canvas.getContext('2d', {willReadFrequently:true});
        ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
        const px = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        let left=canvas.width, right=0, top=canvas.height, bottom=0;
        for (let y=0; y<canvas.height; y++) {
          let count=0, first=canvas.width, last=0;
          for (let x=0; x<canvas.width; x++) {
            const i=(y*canvas.width+x)*4;
            if (px[i+3]>40 && Math.min(px[i],px[i+1],px[i+2])<238) {count++;first=Math.min(first,x);last=x;}
          }
          if(count>=3){left=Math.min(left,first);right=Math.max(right,last);top=Math.min(top,y);bottom=y;}
        }
        const bw=(right-left+1)/canvas.width, bh=(bottom-top+1)/canvas.height;
        if (bh<0.35 || bw>0.65 || bw<=0 || (bh/bw)/ratio<1.8) return;
        const media=img.closest('.product-media');
        if (!media) return;
        media.classList.add('tew-normalized-bottle');
        img.style.setProperty('--tew-bottle-height', (80/bh)+'%');
        img.style.setProperty('--tew-bottle-desktop-height', (70/bh)+'%');
        img.style.setProperty('--tew-bottle-x', (-100*(left+right+1)/2/canvas.width)+'%');
        img.style.setProperty('--tew-bottle-y', (-100*(top+bottom+1)/2/canvas.height)+'%');
        img.dataset.tewBottleNormalized='true';
      } catch (_) {
        if (!img.dataset.tewBottleCorsRetry) {
          img.dataset.tewBottleCorsRetry='true';
          const probe=new Image(); probe.crossOrigin='anonymous';
          probe.onload=()=>run(probe); probe.src=img.currentSrc || img.src;
        }
      }
    };
    if(img.complete) run(); else img.addEventListener('load',()=>run(),{once:true});
  }
  const scan = root => { if(root.matches?.(selector)) normalize(root); root.querySelectorAll?.(selector).forEach(normalize); };
  const start = () => {scan(document);new MutationObserver(records=>records.forEach(r=>r.addedNodes.forEach(n=>{if(n.nodeType===1)scan(n);}))).observe(document.body,{childList:true,subtree:true});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

})();
